export var presetStrokeColors = {
  default: "var(--ds-border-selected, #0C66E4)",
  warning: "var(--ds-border-warning, #E56910)"
};
export var presetStrokeWidth = "var(--ds-border-width-outline, 2px)";